import * as tslib_1 from "tslib";
import { ModalPlantedTreesComponent } from './modal-planted-trees/modal-planted-trees/modal-planted-trees.component';
import { OnInit } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap';
import { defer } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
export class PlantingSiteDetailsComponent {
    constructor(route, plantingSiteService, router, location, messageService, collectionService, ngoService, customerService, previousRouteService, _modalService) {
        this.route = route;
        this.plantingSiteService = plantingSiteService;
        this.router = router;
        this.location = location;
        this.messageService = messageService;
        this.collectionService = collectionService;
        this.ngoService = ngoService;
        this.customerService = customerService;
        this.previousRouteService = previousRouteService;
        this._modalService = _modalService;
        this.selectedTab = 'general';
        this.saving = false;
        this.treeSpecies = {};
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.returnRoute = this.previousRouteService.getPreviousUrl();
            this.route.data.subscribe(value => {
                this.site = value.plantingSite || { collections: [] };
                this.isNew = !this.site.id;
                this.currentUser = value.currentUser;
            });
            this.documentationTitles$ = this.collectionService.getAllTitles().pipe(shareReplay(1));
            this.countries$ = defer(() => this.plantingSiteService.getCountries()).pipe(shareReplay(1));
            this.customerCountries$ = defer(() => this.customerService.getCountries()).pipe(shareReplay(1));
            this.regions$ = defer(() => this.plantingSiteService.getRegions()).pipe(shareReplay(1));
            this.ngoPartners$ = defer(() => this.ngoService.getNgoPartners()).pipe(shareReplay(1));
            this.customers$ = defer(() => this.customerService.getCustomers()).pipe(shareReplay(1));
            this.speciesDto$ = yield this.plantingSiteService.getAllSpecies();
            this.route.paramMap.subscribe(params => {
                if (!this.tabSet)
                    return;
                this.selectedTab = params.get('tab') || '';
                let tab = this.tabSet.tabs.find(tab => tab.elementRef.nativeElement.id == this.selectedTab);
                if (tab)
                    tab.active = true;
                else
                    this.router.navigateByUrl('/pageNotFound');
                this.areaId = params.get('tabId');
                this.secondTab = params.get('secondtab');
                this.collectionId = params.get('secondtabId');
                if (this.secondTab)
                    this.selectedSiteArea = this.site.areas.find(f => f.id === this.areaId);
            });
            this.calculateMiscAmount();
        });
    }
    saveSite(arg) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let site = arg.site;
            this.saving = true;
            let siteId = yield this.plantingSiteService.save(site);
            if (arg.file) {
                var result = yield this.plantingSiteService.updateSitePhoto(arg.file, siteId);
                site.headerPhoto = result.data;
            }
            if (arg.LandOWerfile) {
                var result = yield this.plantingSiteService.updateLandOwnerPhoto(arg.LandOWerfile, siteId);
                site.landOwnerPhoto = result.data;
            }
            if (arg.LandOWerfile == null && site.landOwnerPhoto == null) {
                var result = yield this.plantingSiteService.deleteLandOwnerPhoto(siteId);
            }
            if ((arg.pdfFile.isChanged) || (arg.pdfFile.isDeleted && arg.site.pdfUrl)) {
                const pdfFile = arg.pdfFile.isChanged ? arg.pdfFile.file : new File([new Blob()], '');
                var pdfResult = yield this.plantingSiteService.updateSitePDF(pdfFile, siteId);
                site.pdfUrl = pdfResult.data;
            }
            if (this.isNew) {
                this.router.navigate(['/admin', 'plantingSites', siteId], { replaceUrl: true });
            }
            else {
                this.updateGenInfo(site);
            }
            this.saving = false;
            this.messageService.showMessage(`Planting Site ${site.title} Saved`, "success" /* Success */);
        });
    }
    cancel() {
        if (this.shoudGoToSites(this.returnRoute)) {
            this.router.navigate(['/admin', 'plantingSites']);
        }
        else {
            this.router.navigateByUrl(this.returnRoute);
        }
    }
    shoudGoToSites(url) {
        return url == '/' || url.toLowerCase().indexOf('login') > -1;
    }
    putTabInUrl(tabName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.plantingSiteService.getById(this.site.id).then(site => {
                this.updateGenInfo(site);
            });
            let currentTab = this.tabSet.tabs.find(tab => tab.elementRef.nativeElement.id == this.selectedTab);
            if (currentTab.elementRef.nativeElement.id === tabName)
                return;
            let navigated = yield this.router.navigate(['/admin', 'plantingSites', this.site.id, tabName], { relativeTo: this.route, replaceUrl: true });
            if (!currentTab)
                return;
            if (navigated === undefined || navigated == null)
                return;
            //navigated is false if cancelled, but null if not navigated because we're already there
            if (!navigated)
                currentTab.active = true;
        });
    }
    collectionsChange(collections) {
        this.site.collections = collections;
    }
    updateGenInfo(site) {
        this.site.title = site.title;
        this.site.country = site.country;
        this.site.region = site.region;
        this.site.partners = site.partners;
        this.site.landOwner = site.landOwner;
        this.site.plantingDate = site.plantingDate;
        this.site.totalTrees = site.totalTrees;
        this.site.lon = site.lon;
        this.site.lat = site.lat;
        this.site.description = site.description;
        this.site.singleDonorMessage = site.singleDonorMessage;
        this.site.headerPhoto = site.headerPhoto;
        this.site.photoPosition = site.photoPosition;
    }
    openModal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const getmiscAmount = sessionStorage.getItem('miscAmount_' + this.selectedSiteArea.id);
            if (getmiscAmount) {
                this.miscAmount = parseInt(getmiscAmount);
                sessionStorage.removeItem('miscAmount_' + this.selectedSiteArea.id);
            }
            this.treeSpecies = {};
            const initialState = {
                speciesDto: this.speciesDto$,
                misc: this.miscAmount,
                isEditPlantedTree: false,
                plantingSiteAreaId: this.selectedSiteArea.id,
                treeSpecies: this.treeSpecies,
            };
            this.modalRef = this._modalService.show(ModalPlantedTreesComponent, {
                class: "modal-lg",
                initialState,
                keyboard: false,
            });
            this.modalRef.content.isSaved$.subscribe((value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (value) {
                    this.selectedSiteArea.species.push(this.treeSpecies);
                    this.site.species.push(this.treeSpecies);
                    this.calculateMiscAmount();
                }
            }));
        });
    }
    calculateMiscAmount() {
        if (this.site.totalTrees === undefined)
            return false;
        const sumAllSpecies = this.site.species.reduce((sum, current) => sum + +current.count, 0);
        // this.miscAmount = this.site.totalTrees - sumAllSpecies;
        const sumAllCertificate = this.site.certificates.reduce((sum, current) => sum + +current.count, 0);
        this.miscAmount = sumAllSpecies - sumAllCertificate;
    }
}
